




import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class OK extends Vue {
  @Prop() url: string | undefined

  get formattedUrl () {
    const code = this.url?.split('/').pop()
    return '//ok.ru/videoembed/' + code
  }

  mounted() {
    this.$emit('video-mounted')
  }
}
